import type { SxProps, Theme } from '@mui/material/styles'

export const TEMPLATE_SKELETON_LINE: SxProps<Theme> = {
  borderRadius: '6px',
}

export const TEMPLATE_SKELETON_ROUNDED: SxProps<Theme> = {
  borderRadius: '12px',
}
